import { createFileRoute } from '@tanstack/react-router';
import { DataImportUploadPage } from '@/pages/data-imports/ui/DataImportUploadPage';

/**
 * 新規取込ルート
 */
export const Route = createFileRoute('/_protected/data-import/upload')({
  component: DataImportUploadPage,
});
